module.exports = __webpack_public_path__ + "static/media/1025893.4220b116.jpg";